module.exports = {"141022100":"唐兴镇","141022101":"南梁镇","141022102":"里砦镇","141022103":"隆化镇","141022104":"桥上镇","141022105":"西阎镇","141022200":"中卫乡","141022201":"南唐乡","141022202":"王庄乡","141022203":"浇底乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141022.json
// module id = 363
// module chunks = 0